<template>
  <section class="app-container checklist-view form-high-contrast">
    <div class="container">
      <Loader v-if="loading" />
      <div v-if="!loading && checklist">
        <div class="pull-right text-right" v-if="checklist">
          <router-link v-if="userCanEdit()" class="btn btn-primary" :to="{ name: 'checklist_edit', params: { id: checklist.id }}"><span class="fa fa-edit"></span> Edit</router-link><br />
          <button style="margin-top:10px;" class="btn btn-sm" onclick="window.print();"><span class="fa fa-print"></span> Print</button>
        </div>
        <h2 class="d-print-none">
          {{checklist.datetime.split('T')[0] | moment(momentDisplayFormat())}} @ <span class="notranslate" translate="no">{{checklist_location.display_name}}</span> by 
          <router-link :to="{ name: 'profile', params: { id: checklist_user.id }}">
            {{checklist_user.display_name}}
          </router-link>
        </h2>
        <div class="d-print-block d-none">
          <h1>Odonata Central Checklist</h1>
          <a href="">www.odonatacentral.com</a>
          <br /><br />
          {{checklist.datetime.split('T')[0] | moment(momentDisplayFormat())}}<br />
          <span class="notranslate" translate="no">{{checklist_location.display_name}} - {{checklist_location_parent.display_name}}</span><br />
          {{checklist_location.latitude}}, {{checklist_location.longitude}}<br />
          {{checklist_user.display_name}}<span v-if="records"> - {{records.length}} record(s)</span>
          <br />
          <br />
        </div>
        <div v-if="checklist.projects">
          <strong>Project(s):&nbsp;</strong>
          <span class="label label--inline" v-for="project in checklist.projects">
            {{project.name}}
          </span>
          <br />
          <br />
        </div>
        <h4 v-if="checklist.observer && !editing_checklist">Observed by <em>{{checklist.observer}}</em></h4>
        <h4 v-if="checklist.observer == '' && !editing_checklist">Observed by a third party</h4>
        <RecordsList v-model="records" :meta="records_meta" hideUser="true" :lifeStages="life_stages"></RecordsList>
      </div>
    </div>
  </section>
</template>

<script>
import global_data from '../../main';
export default {
  name: 'ChecklistViewComponent',
  metaInfo() {
    return {
      title: this.meta_title,
      meta: [
        { name: "description", content: this.meta_description },
      ],
    }
  },
  data: function(){
    return {
      checklist:null,
      checklist_location_parent:null,
      checklist_location:null,
      checklist_user: null,
      records: null,
      records_meta: null,
      loading:true,
      meta_title: "Sighting Checklist",
      meta_description: "Sighting Checklist",
      life_stages:null,
    };
  },
  mounted: function(){
    this.bindChecklist();
    this.bindSightings();
  },
  methods:{
    userCanEdit:function(){
      if (!global_data.OCUser) {
        return false;
      }
      return global_data.OCUser.id == this.checklist_user.id;
    },
    bindSightings: function(){
      var self = this;
      var qs = "&include[]=checklist.user.*";
      qs += "&include[]=checklist.location.*";
      qs += "&include[]=checklist.location.parent.*";
      qs += "&include[]=status.*";
      qs += "&include[]=checklist.*";
      qs += "&include[]=taxon.*";
      qs += "&include[]=life_stage.*";
      qs += "&include_declined=true";
      qs += "&filter{checklist.id}=" + this.$route.params.id;
      qs += '&per_page=1000';
      qs +="&sort[]=taxon.suborder.scientific_name";
      qs +="&sort[]=taxon.family.scientific_name";
      qs +="&sort[]=taxon.scientific_name";

      this.API({
        endpoint: 'sightings',
        querystring: qs,
        funcThen: function(response){
          self.records_meta = response.data.meta;
          self.records = self.CombineSightingData(response.data);
          self.life_stages = response.data.life_stages;
        },
        funcAfterThen: function(){
          self.records_loading = false;
        }
      });
    },
    bindChecklist: function(){
      var self = this;
      var qs = "&include[]=user.*";
      qs += "&include[]=location.*";
      qs += "&include[]=location.parent.*";
      var indexed_taxon = [];
      this.API({
        endpoint: 'checklists/' + this.$route.params.id,
        querystring: qs,
        funcThen: function(response){
          self.checklist = response.data.checklist;
          self.checklist_user = response.data.users.find(u => u.id == self.checklist.user);
          self.checklist_location = response.data.locations.find(l => l.id == self.checklist.location);
          self.checklist_location_parent = response.data.locations.find(l => l.id == self.checklist_location.parent);
          self.meta_title = self.checklist.datetime.split('T')[0] + " at " + self.checklist_location.display_name + " by " + self.checklist_user.display_name;
          self.meta_description = "Dragonfly & Odonata Checklist for " + self.checklist.datetime.split('T')[0] + " at " + self.checklist_location.display_name + " by " + self.checklist_user.display_name;
        },
        funcAfterThen:function(){
          self.loading = false;
        }
      });
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/pages/ChecklistView.vue